import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import {
  CommunicationManagerService,
  Company,
  CompanyService,
  EnumService,
  LocalStorageService,
  SessionManagerService,
  StubCompany,
  User,
  UsersService,
} from '@ops/shared-types';
import { DebounceClickDirective } from '@ops/components';
import { Router } from '@angular/router';

@Component({
  selector: 'ops-create-company',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    OpsInputComponent,
    OpsCalendarComponent,
    OpsSelectComponent,
    DebounceClickDirective,
  ],
  templateUrl: './ops-create-company.component.html',
  styleUrl: './ops-create-company.component.scss',
})
export class OpsCreateCompany implements OnInit, OnDestroy {
  @Input() subscriptionId = '';
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() createdCompany: EventEmitter<any> = new EventEmitter<any>();

  private currentUser: User | null = null;

  errorsTrack = {};

  dayOptions = Array.from({ length: 28 }, (_, i) => i + 1); // Days 1-31
  monthOptions = Array.from({ length: 12 }, (_, i) => i + 1); // Months 1-12

  startingYearNow = new Date().getFullYear();
  yearsOptions = Array.from({ length: 51 }, (_, i) => this.startingYearNow - i); // Years from now - 50years

  defaultSelectedYear = this.startingYearNow;

  selectedCompany: Company = {
    ...StubCompany,
    dateOfEstablishment: new Date(this.defaultSelectedYear, 0, 3),
  };

  mainCurrencies = [];

  constructor(
    private cm: CommunicationManagerService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private userService: UsersService,
    private sessionManager: SessionManagerService,
    private enumService: EnumService
  ) {
    this.currentUser =
      JSON.parse(sessionStorage.getItem('user') || '{}') ?? undefined;
  }

  ngOnInit(): void {
    this.mainCurrencies = this.enumService
      .getCurrencyOptionsDetailed()
      .map((cop: any) => {
        return { key: cop.name, value: cop.shortName };
      });
  }

  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
  }

  updateDateOfEstablishment(date: Date) {
    this.selectedCompany.dateOfEstablishment = date ?? null;
  }

  get isValidData(): boolean {
    return (
      !!this.selectedCompany.name &&
      !!this.selectedCompany.fiscalYearStartDay &&
      !!this.selectedCompany.fiscalYearStartMonth &&
      !!this.selectedCompany.dateOfEstablishment &&
      !!this.selectedCompany.baseCurrencyCode
    );
  }

  onSelectChange(selectValue: string, field?: string): void {
    this.selectedCompany[field] = selectValue;
  }

  onInputChange(newValue: string, field?: string): void {
    this.selectedCompany[field] = newValue;
  }

  onInputYearChange(newValue: number): void {
    this.defaultSelectedYear = newValue;
    this.selectedCompany.dateOfEstablishment = new Date(
      this.defaultSelectedYear,
      0,
      3
    );
  }

  onErrorHandler(error: string, field?: string) {
    if (!error || error === '') {
      delete this.errorsTrack[field];
    } else {
      this.errorsTrack[field] = error;
    }
  }

  saveChanges() {
    delete this.selectedCompany.type;
    // console.log('selectedCompany', this.selectedCompany);
    this.companyService
      .createAdminCompany({
        ...this.selectedCompany,
        subscriptionId: this.subscriptionId,
      })
      .subscribe((company: Company) => {
        if (company?._id) {
          this.createdCompany.emit(company);
          // const companyId = company._id;
          // const companyRole = {
          //   company: companyId,
          //   role: 'admin',
          // } as CompanyRole;
          // this.localStorageService.setCurrentCompany({
          //   _id: companyId,
          //   name: company.name,
          //   shortName: company.shortName,
          // });
          // this.sessionManager.setCurrentCompany(companyId);
          // this.userService
          //   .addOrUpdateUserCompanyRole(
          //     this.sessionManager.getUser()._id,
          //     companyRole
          //   )
          //   .subscribe(() => {
          //     const extendedUser = {
          //       ...this.sessionManager.getUser(),
          //       companies: [companyRole],
          //     };
          //     this.sessionManager.setCurrentUser(extendedUser);
          //     this.router.navigateByUrl('/dashboard');
          //   });
          // // this.addOrUpdateUserCompanyRole
        }
      });
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
